/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { CSSProperties } from 'react'

import styled, { css, Interpolation } from 'styled-components'

import { BaseButton } from 'src/components/Button'
import FlexBox from 'src/components/Common/FlexBox'
import Icon from 'src/components/Icon'
import { useThemeContext } from 'src/contexts/ThemeContext'
import { pxToVw } from 'src/functions/units'

type Props = {
  hidden?: boolean
  size?: number
  style?: Interpolation<CSSProperties>
  onClick: () => void
}

const ModalV2CloseButton = ({ hidden = false, size = 24, style, onClick }: Props) => {
  const { colors } = useThemeContext()

  if (hidden) return null

  return (
    <StyledCloseButton onClick={onClick} style={style}>
      <FlexBox as="span" alignItems="center" justifyContent="center">
        <Icon icon={'close'} size={size || 24} color={colors.gray300} />
      </FlexBox>
    </StyledCloseButton>
  )
}

export default ModalV2CloseButton

const StyledCloseButton = styled(BaseButton)<Pick<Props, 'style'>>`
  padding: 0;
  display: inline-flex;
  height: fit-content;
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  position: absolute;
  top: ${pxToVw(40)};
  right: ${pxToVw(40)};
  z-index: 2;

  ${({ style }) => style}

  ${({ theme }) => css`
    ${theme.mediaQuery.mobile`
      top: ${pxToVw(40, 720)};
      right: ${pxToVw(40, 720)};
    `}
  `}
`
